module.exports = __webpack_public_path__ + "img/banking.63c5604.webp";